module.exports = __webpack_public_path__ + "img/webcam_W.cf54e3bb.png";